// this code for to view the credit orders from agents to approve or reject "button : "
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  Timestamp,
  increment,
  orderBy,
  query,
  deleteDoc,
} from "firebase/firestore";

const CreditRequests = () => {
  const [creditRequests, setCreditRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const fetchRequests = async () => {
    try {
      const q = query(
        collection(db, "creditRequests"),
        orderBy("timestamp", "desc")
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCreditRequests(data);
    } catch (error) {
      console.error("Error fetching credit requests:", error);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleDecision = async (decision) => {
    if (!selectedRequest) return;

    try {
      const requestRef = doc(db, "creditRequests", selectedRequest.id);

      await updateDoc(requestRef, {
        status: decision,
        adminActionDate: Timestamp.now(),
        approvedAt: decision === "approved" ? Timestamp.now() : null,
        rejectedAt: decision === "rejected" ? Timestamp.now() : null,
      });

      if (decision === "approved") {
        const userRef = doc(db, "users", selectedRequest.uid);
        await updateDoc(userRef, {
          credits: increment(selectedRequest.credits),
        });
      }

      alert(`Request ${decision}`);
      setSelectedRequest(null);
      fetchRequests();
    } catch (error) {
      console.error("Error updating request:", error);
      alert("Failed to update request");
    }
  };

  const deleteRequest = async (requestId) => {
    try {
      await deleteDoc(doc(db, "creditRequests", requestId));
      alert("Request deleted successfully!");
      // Optionally refresh the list
      fetchRequests();
    } catch (error) {
      console.error("Error deleting request:", error);
      alert("Failed to delete request.");
    }
  };

  return (
    <div className="container mt-4">
      <h3>Credit Requests</h3>
      {creditRequests.length === 0 ? (
        <p>No credit requests found.</p>
      ) : (
        <table className="table table-bordered table-hover mt-3">
          <thead className="table-light">
            <tr>
              <th>Account ID</th>
              <th>Agent Name</th>
              <th>Credits</th>
              <th>Payment Type</th>
              <th>Status</th>
              <th>Requested At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {creditRequests.map((req) => (
              <tr
                key={req.id}
                onClick={() => setSelectedRequest(req)}
                style={{ cursor: "pointer" }}
              >
                {/* <td>{req.id}</td> */}
                <td>{req.accountId}</td>
                <td>{req.username}</td>
                <td>{req.credits}</td>
                <td>{req.paymentType}</td>
                <td style={{ textTransform: "capitalize" }}>{req.status}</td>
                <td>
                  {req.timestamp
                    ? new Date(req.timestamp.seconds * 1000).toLocaleString()
                    : "-"}
                </td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={(e) => {
                      e.stopPropagation();

                      deleteRequest(req.id);
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selectedRequest && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setSelectedRequest(null)}
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Request Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedRequest(null)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  <strong>Account ID:</strong> {selectedRequest.accountId}
                </p>
                <p>
                  <strong>Agent Name:</strong>{" "}
                  {selectedRequest.username ||
                    selectedRequest.fullname ||
                    selectedRequest.name ||
                    "none"}
                </p>
                <p>
                  <strong>Credits:</strong> {selectedRequest.credits}
                </p>
                <p>
                  <strong>Payment Type:</strong> {selectedRequest.paymentType}
                </p>
                <p>
                  <strong>Remarks:</strong> {selectedRequest.remarks || "-"}
                </p>
                <p>
                  <strong>UTR:</strong> {selectedRequest.utr || "-"}
                </p>
                <p>
                  <strong>Status:</strong> {selectedRequest.status}
                </p>
              </div>
              <div className="modal-footer">
                {selectedRequest.status === "pending" && (
                  <>
                    <button
                      className="btn btn-success"
                      onClick={() => handleDecision("approved")}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDecision("rejected")}
                    >
                      Reject
                    </button>
                  </>
                )}
                <button
                  className="btn btn-secondary"
                  onClick={() => setSelectedRequest(null)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreditRequests;
